export const KEYS = {
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    USER_ROLE: 'USER_ROLE',
    USER_EMAIL: 'USER_EMAIL',
    USER_REMEMBER: 'USER_REMEMBER',
    USER_LAST_LOGIN: 'USER_LAST_LOGIN',
    USER_IS_LOGIN: 'USER_IS_LOGIN',
    SHOULD_UPDATE_TOKEN: 'SHOULD_UPDATE_TOKEN',
    REMEMBER_EMAIL: 'REMEMBER_EMAIL',
    REMEMBER_ROLE: 'REMEMBER_ROLE',
    COMMIT_VERSION: 'COMMIT_VERSION',
    APP_PAGE: 'APP_PAGE',
    APP_PAGE_SIZE: 'APP_PAGE_SIZE',
    AMEND_PAGE: 'AMEND_PAGE',
    AMEND_PAGE_SIZE: 'AMEND_PAGE_SIZE',
};

export const getItem = (key, defaultValue) => {
    try {
        const temp = JSON.parse(sessionStorage.getItem(key)) || defaultValue;
        return temp;
    } catch (error) {
        console.log('093927 index.js get session storage item fail, returning the default value');
    }
};

export const setItem = (key, value) => {
    try {
        const temp = JSON.stringify(value);
        sessionStorage.setItem(key, temp);
        return true;
    } catch (error) {
        console.log('093711 index.js setting session storage item failed');
        return false;
    }
};

export const removeItem = (key) => {
    try {
        sessionStorage.removeItem(key);
        return true;
    } catch (error) {
        console.log('093927 index.js get session storage item fail, returning the default value');
        return false;
    }
};
